import { watch, Ref } from 'vue';

export function usePageTitle(title: Ref<string> | string) 
{
    watch(() => (typeof title === 'string' ? title : title.value), async (newTitle) => 
    {
        document.title = newTitle;
    },{ immediate: true });
}